import en from './en'
import cs from './cs'
import VueI18n from 'vue-i18n'

const i18n = new VueI18n({
  locale: 'cs',
  fallbackLocale: 'en',
  messages: {
    en,
    cs
  }
})

export default i18n

if (module.hot) {
  module.hot.accept(['./en', './cs'], () => {
    i18n.setLocaleMessage('en', require('./en').default)
    i18n.setLocaleMessage('cs', require('./cs').default)
  })
}



// WEBPACK FOOTER //
// ./src/locale/index.js